import { Configuration } from '@ulysses-inc/harami_api_client'
import { getBasePath } from '~/config'
import { getHeaders } from './headers'
import { preMiddlewares } from './middleware'
import type { BaseAPI } from '@ulysses-inc/harami_api_client'

export const useAuthApi = () => {
  const getApi = <T extends BaseAPI>(api: new (config: Configuration) => T) => {
    const config = new Configuration({
      basePath: getBasePath(),
      headers: getHeaders(),
      credentials: 'include',
    })
    const instance = new api(config)
    return preMiddlewares.reduce((a, m) => {
      return a.withPreMiddleware(m)
    }, instance)
  }

  return { getApi }
}

export type GetApiType = ReturnType<typeof useAuthApi>['getApi']
